import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconScreenCapture: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="screen-capture, recording"><path d="M2.75 7.25V4.75H5.25M13.75 4.75H15.25M8.75 4.75H10.25M18.75 4.75H21.25V7.25M10.25 19.25H8.75M5.25 19.25H2.75V16.75M2.75 13.25V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="18.5" cy="15.5" r="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="18.5" cy="15.5" r="0.75" stroke="currentColor" strokeWidth="1.5"/><circle cx="18.5" cy="15.5" r="4.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconScreenCapture;
